import { render, staticRenderFns } from "./RoomsBar.vue?vue&type=template&id=9f8cb23c&scoped=true&"
import script from "./RoomsBar.vue?vue&type=script&lang=js&"
export * from "./RoomsBar.vue?vue&type=script&lang=js&"
import style0 from "./RoomsBar.vue?vue&type=style&index=0&id=9f8cb23c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8cb23c",
  null
  
)

export default component.exports